import React from "react"
import { Container } from "reactstrap"

import Breadcrumbs from "../../components/Common/Breadcrumb"
import DatatableTables from "./DatatableTables"
import MetaTag from "components/Common/Meta-tag"

function Inspection() {
  return (
    <>
      <MetaTag title={"Documents"} />

      <div className="page-content">
        <Breadcrumbs title="Dashboard" breadcrumbItem="Documents" />
        <Container fluid>
          <div className="container-fluid">
            <DatatableTables />
          </div>
        </Container>
      </div>
    </>
  )
}

export default Inspection
